/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface ShowAuthenticatedUserResponse
 */
export interface ShowAuthenticatedUserResponse {
    /**
     * 
     * @type {User}
     * @memberof ShowAuthenticatedUserResponse
     */
    data: User;
}

/**
 * Check if a given object implements the ShowAuthenticatedUserResponse interface.
 */
export function instanceOfShowAuthenticatedUserResponse(value: object): value is ShowAuthenticatedUserResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowAuthenticatedUserResponseFromJSON(json: any): ShowAuthenticatedUserResponse {
    return ShowAuthenticatedUserResponseFromJSONTyped(json, false);
}

export function ShowAuthenticatedUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowAuthenticatedUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': UserFromJSON(json['data']),
    };
}

  export function ShowAuthenticatedUserResponseToJSON(json: any): ShowAuthenticatedUserResponse {
      return ShowAuthenticatedUserResponseToJSONTyped(json, false);
  }

  export function ShowAuthenticatedUserResponseToJSONTyped(value?: ShowAuthenticatedUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UserToJSON(value['data']),
    };
}

